import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Reveal, SectionLabel } from './Section';
import { CURRICULUM } from '../data/content';
import { Plus, Minus } from 'lucide-react';

export default function Curriculum() {
  const [open, setOpen] = useState(0);
  return (
    <section id="curriculum" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[0.9fr_1.4fr] gap-14">
        <div>
          <Reveal><SectionLabel>The Curriculum</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[62px] leading-[1.02] font-semibold text-[#293891] mt-6">
              Ten phases. <br/>One <span className="text-[#E63329]">career-ready data scientist.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-[15px] leading-relaxed text-[#293891]/75 max-w-md">
              A structured path from data foundations to autonomous AI analyst agents and end-to-end Machine Learning — every phase stacks on the last.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex items-center gap-6">
              <div>
                <div className="font-display text-[46px] font-semibold text-[#293891] leading-none">10</div>
                <div className="text-[11px] tracking-[0.2em] uppercase text-[#293891]/75 mt-2 font-semibold">Phases</div>
              </div>
              <div className="w-px h-14 bg-[#293891]/15"/>
              <div>
                <div className="font-display text-[46px] font-semibold text-[#293891] leading-none">6</div>
                <div className="text-[11px] tracking-[0.2em] uppercase text-[#293891]/75 mt-2 font-semibold">Months</div>
              </div>
            </div>
          </Reveal>
        </div>

        <div>
          {CURRICULUM.map((p, i) => {
            const isOpen = open === i;
            return (
              <div key={p.num} className="acc-item">
                <button onClick={() => setOpen(isOpen ? -1 : i)} className="w-full flex items-center justify-between py-6 text-left group">
                  <div className="flex items-center gap-6">
                    <span className="text-[13px] font-semibold text-[#E63329] tracking-widest">{p.num}</span>
                    <span className="font-display text-[22px] sm:text-[26px] font-semibold text-[#293891] group-hover:text-[#E63329] transition-colors">{p.title}</span>
                  </div>
                  <span className="w-9 h-9 rounded-full border border-[#293891]/25 flex items-center justify-center text-[#293891]">
                    {isOpen ? <Minus size={16}/> : <Plus size={16}/>}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div initial={{height:0, opacity:0}} animate={{height:'auto', opacity:1}} exit={{height:0, opacity:0}} transition={{duration:0.35}} className="overflow-hidden">
                      <ul className="pb-8 grid sm:grid-cols-2 gap-x-8 gap-y-2 pl-10">
                        {p.topics.map(t => (
                          <li key={t} className="text-[13.5px] text-[#293891]/75 flex items-start gap-2">
                            <span className="text-[#E63329] mt-1">•</span>{t}
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
